import React from 'react';
import PackageCard from '../components/PackageCard';
import BeforeYouBook from '../components/BeforeYouBook';
import { Helmet } from 'react-helmet-async';
const StandardLessonsPage = () => {
  const standardPackages = [{
    title: '2 Hour Package',
    price: '£76',
    originalPrice: '£80',
    description: '£38 per hour - Automatic lessons for beginners or refresher sessions.',
    features: ['Save £4 on standard pricing', 'Behind-the-wheel training', 'Traffic rules and regulations', 'Flexible scheduling'],
    saving: '£4',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '6 Hour Package',
    price: '£225',
    originalPrice: '£240',
    description: '£37.50 per hour - Build your confidence and skills with multiple sessions.',
    features: ['Save £15 on standard pricing', 'Comprehensive driving practice', 'Manoeuvre training', 'Urban and suburban driving'],
    saving: '£15',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '10 Hour Package',
    price: '£370',
    originalPrice: '£400',
    description: '£37 per hour - Popular standard package for automatic lessons.',
    features: ['Save £30 on standard pricing', 'Complete driving skills coverage', 'Junction and roundabout mastery', 'Test preparation guidance'],
    popular: true,
    saving: '£30',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Package',
    price: '£710',
    originalPrice: '£800',
    description: '£35.50 per hour - Comprehensive training for complete beginners.',
    features: ['Save £90 on standard pricing', 'Full driving curriculum', 'Advanced manoeuvres', 'Night driving practice'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-1745" data-mp="5pewqdt3t1yc">
      <Helmet data-id="element-1746" data-mp="5qhkicv4qoa1">
        <title data-id="element-1747" data-mp="5q81xacezjed">Automatic Driving Lessons & Intensive Courses Northampton</title>
        <meta name="description" content="Learn at your own pace with flexible packages, or intensive driving courses in Northampton. Our 10-hour package is most popular with students." data-id="element-1748" data-mp="9s34ei6302tq" />
        <meta name="keywords" content="automatic driving lessons Northampton, driving packages Northampton, block booking driving lessons, 10-hour driving lessons Northampton, automatic driving course deals Northampton, popular driving lesson packages Northampton" data-id="element-1749" data-mp="jmbs8sk637lk" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1750" data-mp="12enxpo64aozx">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1751" data-mp="12g7b970e2ly0">
          Standard Driving Lessons
        </h1>
        <h2 className="sr-only" data-id="element-1752" data-mp="17e0hg01ozfya">10-Hour Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-1753" data-mp="1hip72cfzzm92">Block Booking Discounts for Driving Lessons</h2>
        <h2 className="sr-only" data-id="element-1754" data-mp="1ci1j5zn2flj2">
          Automatic Driving Lesson Packages Northampton
        </h2>
        <div className="mb-8" data-id="element-1755" data-mp="17iyg2kqnbpdq">
          <p className="text-gray-700" data-id="element-1756" data-mp="17k00vgxgrq8n">
            Our standard driving lessons are designed to fit around your
            schedule, allowing you to learn at your own pace. All lessons are
            conducted in automatic cars by qualified instructors who will tailor
            their teaching to your individual needs. Our 10-hour package is the
            most popular choice among our students.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1757" data-mp="1qfzlu7s0xtiq">
          {standardPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1758" data-mp="2iywruwd7kpin" data-mpi={index} />)}
        </div>
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-1759" data-mp="2e7yb5vob5pev">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1760" data-mp="2e6dhs9dqccil">
            What's Included in Our Standard Lessons?
          </h2>
          <ul className="space-y-4" data-id="element-1761" data-mp="1yrzz5a1diuzb">
            <li className="flex" data-id="element-1762" data-mp="23pjde9y2n7r9">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1763" data-mp="23ql05bog9iot">
                ✓
              </div>
              <div data-id="element-1764" data-mp="1pr1poc861v9c">
                <strong data-id="element-1765" data-mp="1prlb42x0z1s4">Personalised Instruction</strong> - Lessons tailored to
                your learning style and experience level.
              </div>
            </li>
            <li className="flex" data-id="element-1766" data-mp="2hh6kl4tjy0ot">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1767" data-mp="2mfhs38wdjz3v">
                ✓
              </div>
              <div data-id="element-1768" data-mp="28ocsu7wx58u2">
                <strong data-id="element-1769" data-mp="28n1n42jwxr0b">Automatic Vehicles</strong> - Modern, dual-controlled
                automatic cars that are easy to learn in.
              </div>
            </li>
            <li className="flex" data-id="element-1770" data-mp="30fivow40xkn1">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1771" data-mp="30e7oembddur6">
                ✓
              </div>
              <div data-id="element-1772" data-mp="357k2i2ifaj5o">
                <strong data-id="element-1773" data-mp="3583ktkbzj9k8">Comprehensive Coverage</strong> - All aspects of
                driving, from basics to advanced manoeuvres.
              </div>
            </li>
            <li className="flex" data-id="element-1774" data-mp="or5lzf34mhy3">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1775" data-mp="opug99q4f04c">
                ✓
              </div>
              <div data-id="element-1776" data-mp="yhqimwz8pced">
                <strong data-id="element-1777" data-mp="yh70bf5oglzt">Flexible Scheduling</strong> - Lessons available
                weekdays, evenings, and weekends.
              </div>
            </li>
            <li className="flex" data-id="element-1778" data-mp="au8lelx7hm40">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1779" data-mp="5tb5kfzo545o">
                ✓
              </div>
              <div data-id="element-1780" data-mp="kqlqefy7bme2">
                <strong data-id="element-1781" data-mp="kr3jx4thbmia">Progress Tracking</strong> - Regular feedback and
                progress updates.
              </div>
            </li>
          </ul>
        </div>
        <div className="text-center" data-id="element-1782" data-mp="1w4z9l7i0fdnr">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1783" data-mp="1w3xla1bzguo3">Ready to Get Started?</h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1784" data-mp="1r779vrb4in90">
            Start your journey with our affordable automatic driving lessons in
            Northampton — flexible hourly and package options available.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-1785" data-mp="236udb1e6r1q8">
            <BeforeYouBook data-id="element-1786" data-mp="2878ogsb32rsh" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton" data-id="element-1787" data-mp="288bg52g8cy9g">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default StandardLessonsPage;